// Document Generation API Service
import { generateDocumentUrl } from '../utils/crypto';

class DocumentApiService {
  constructor() {
    // API endpoint base URL
    this.baseUrl = '/api';
  }

  async generateDocument(params) {
    try {
      // GET 방식으로 변경 - 암호화된 URL 생성
      const documentUrl = generateDocumentUrl(params);
      
      if (!documentUrl) {
        throw new Error('Failed to generate encrypted URL');
      }

      // API 응답 형식으로 반환
      return {
        success: true,
        documentUrl: documentUrl,
        parameters: params
      };
    } catch (error) {
      console.error('Document API Error:', error);
      throw error;
    }
  }
}

// 사용 예시
/*
const api = new DocumentApiService();

// POST 요청으로 문서 생성
const result = await api.generateDocument({
  orderId: '123456789',
  documentType: 'both', // 'packing', 'commercial', 'both'
  signedBy: 'John Doe',
  invoiceDate: '2025-01-31',
  contractNumber: 'BVC-2025-Q1-001',
  carrier: 'DHL',
  prepaid: true,
  remarks: 'Handle with care',
  sailingDate: '2025-02-15'
});

console.log('Document URL:', result.documentUrl);
// 생성된 URL로 리다이렉트 또는 iframe으로 표시
window.location.href = result.documentUrl;
*/

export default DocumentApiService;